import { render, staticRenderFns } from "./EventTriggerCard.vue?vue&type=template&id=dd8ef83e&"
import script from "./EventTriggerCard.vue?vue&type=script&lang=ts&"
export * from "./EventTriggerCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports